module.exports = __webpack_public_path__ + "672002600886255a63c3548620525a2b.MP3";